import React, { useState } from 'react';
import { Dropdown, Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../../context/ThemeContext';
import { useStores } from '../../Stores/hooks';
import { StoresDropDownProps, Store } from './types';
import { DEFAULT_SELECTED_OPTION } from './constants';
import {
  Container,
  StyledButton,
  ButtonText,
  DropdownContainer,
  OptionList,
  OptionItem,
  LoadingContainer,
} from './styles';

const StoresDropDown: React.FC<StoresDropDownProps> = ({
  onOptionSelect,
  defaultValue = DEFAULT_SELECTED_OPTION,
  value: controlledValue,
}) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  const { data: stores = [], isLoading } = useStores();
  const [selectedOption, setSelectedOption] = useState<string>(defaultValue);
  const [isOpen, setIsOpen] = useState(false);

  const currentValue = controlledValue !== undefined ? controlledValue : selectedOption;

  const handleOptionClick = (option: Store) => {
    if (selectedOption === option?.name) {
      onOptionSelect({ id: '' });
      if (controlledValue === undefined) {
        setSelectedOption(DEFAULT_SELECTED_OPTION);
      }
      setIsOpen(false);
      return;
    }

    if (controlledValue === undefined) {
      setSelectedOption(option?.name);
    }
    onOptionSelect(option);
  };

  return (
    <Container theme={theme}>
      <Dropdown
        trigger={['click']}
        open={isOpen}
        onOpenChange={setIsOpen}
        dropdownRender={() => (
          <DropdownContainer theme={theme}>
            {isLoading ? (
              <LoadingContainer>
                <Spin size="small" />
              </LoadingContainer>
            ) : (
              <OptionList>
                {stores?.map((option) => (
                  <OptionItem
                    key={option?.id}
                    isSelected={currentValue === option?.name}
                    theme={theme}
                    onClick={() => handleOptionClick(option)}
                  >
                    {option.name}
                  </OptionItem>
                ))}
              </OptionList>
            )}
          </DropdownContainer>
        )}
      >
        <StyledButton theme={theme} onClick={(e) => e.preventDefault()}>
          <ButtonText theme={theme}>{currentValue}</ButtonText>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </StyledButton>
      </Dropdown>
    </Container>
  );
};

export default StoresDropDown;
